export default [
  {
    text: '#',
    value: 'id',
    sortable: true,
    width: '5%',
  },
  {
    text: 'código interno',
    value: 'internal_code',
    sortable: true,
    width: '10%',
  },
  {
    text: 'alias',
    value: 'alias_name',
    sortable: true,
  },
  {
    text: 'nombre',
    value: 'name',
    sortable: true,
    width: '20%',
  },
  {
    text:'Stock Bodega',
    value: 'stockWarehouse',
    align:'right',
    format: 'number-point',
  },
  {
    text: 'stock sucursal',
    value: 'stock_branch_office_of_warehouse',
    align: 'right',
    format: 'number-point',
  },
  {
    text: 'stock critico',
    value: 'critical_stock_branch_office_of_warehouse',
    align: 'right',
    format: 'number-point',
  },
  {
    text: 'stock reservado',
    value: 'reservated',
    align: 'right',
  },
  {
    text: 'inventariable',
    value: 'wh_item_is_inventoriable',
    align: 'center',
    format: 'boolean',
  },
  {
    text: 'reenvasable',
    value: 'is_repackaged',
    align: 'center',
    format: 'boolean',
  },
]
